module.exports = __webpack_public_path__ + "static/media/icon.9360cc9c.png";